/**
 * assets/garment-spec.js
 *
 * Broadcast theme helper:
 * - Finds all .gs-block elements (your Custom code blocks)
 * - Reads the JSON map inside .gs-map ({ "<variantId>": "<html>" })
 * - Swaps .gs-content on variant change
 *
 * Works with:
 * - Broadcast pub/sub: subscribe(theme.PUB_SUB_EVENTS.variantChange, ...)
 * - Fallback: listens for change events and reads input[name="id"]
 */
(function () {
  function safeParseJson(text) {
    try {
      return JSON.parse(text || "{}");
    } catch {
      return null;
    }
  }

  function getVariantIdFromBroadcast(payload) {
    // Broadcast typically emits: { data: { variant: { id } } }
    return payload?.data?.variant?.id || payload?.variant?.id || payload?.id || null;
  }

  function getVariantIdFromDomFallback() {
    // Broadcast may have multiple ATC forms (main + sticky). Pick first valid.
    const inputs = document.querySelectorAll('form[action*="/cart/add"] input[name="id"]');
    for (const input of inputs) {
      if (input && input.value) return input.value;
    }
    return null;
  }

  function updateBlock(block, variantId) {
    if (!block || !variantId) return;

    const mapEl = block.querySelector(".gs-map");
    const contentEl = block.querySelector(".gs-content");
    if (!mapEl || !contentEl) return;

    const map = safeParseJson(mapEl.textContent);
    if (!map) return;

    contentEl.innerHTML = map[String(variantId)] ?? "";
  }

  function updateAllBlocks(variantId) {
    if (!variantId) return;
    document.querySelectorAll(".gs-block").forEach((block) => updateBlock(block, variantId));
  }

  function init() {
    // Initial render: prefer the initial id from any block, else the form input
    const firstBlock = document.querySelector(".gs-block[data-gs-initial-variant-id]");
    const initialVariantId =
      firstBlock?.getAttribute("data-gs-initial-variant-id") || getVariantIdFromDomFallback();

    updateAllBlocks(initialVariantId);

    // Preferred: Broadcast variant change event
    if (typeof window.subscribe === "function" && window.theme?.PUB_SUB_EVENTS?.variantChange) {
      window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, (payload) => {
        const id = getVariantIdFromBroadcast(payload) || getVariantIdFromDomFallback();
        updateAllBlocks(id);
      });
      return;
    }

    // Fallback: any option change should update input[name=id]
    document.addEventListener("change", () => {
      setTimeout(() => updateAllBlocks(getVariantIdFromDomFallback()), 0);
    });

    // If URL variant param changes (rare), update too
    window.addEventListener("popstate", () => updateAllBlocks(getVariantIdFromDomFallback()));
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
